<app-preloader></app-preloader>
<app-navbar *ngIf="!hideLayout"></app-navbar>
    <router-outlet></router-outlet>
<app-footer *ngIf="!hideLayout"></app-footer>